import { render, staticRenderFns } from "./OrkLoader.html?vue&type=template&id=7b0d91da&scoped=true&functional=true&"
import script from "./OrkLoader.vue?vue&type=script&lang=js&"
export * from "./OrkLoader.vue?vue&type=script&lang=js&"
import style0 from "./OrkLoader.scss?vue&type=style&index=0&id=7b0d91da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7b0d91da",
  null
  
)

export default component.exports